import { CompPhoneInputCore } from '../core/phone-input/comp'

export const CompPhoneInput = CompPhoneInputCore
